import { connect } from "react-redux";
import {
  reduxForm,
  getFormSubmitErrors,
  getFormAsyncErrors,
  getFormSyncErrors,
  getFormError
} from "redux-form";
import humanizeString from "humanize-string";
import flatten from "flat";

function humanizeFieldName(str) {
  return humanizeString(str.split(".").join(" "));
}

function fieldErrorMsgs(fieldErrors = {}) {
  const cleanErrors = {};

  (Object.keys(fieldErrors) || []).forEach(fieldName => {
    const val = fieldErrors[fieldName];

    if (Array.isArray(val) && val.length > 0 && typeof val[0] === "object") {
      (Object.keys(fieldErrors[fieldName]) || []).forEach(fieldIndex => {
        cleanErrors[`${fieldName}.${parseInt(fieldIndex, 10) + 1}`] =
          fieldErrors[fieldName][fieldIndex];
      });
    } else {
      cleanErrors[fieldName] = fieldErrors[fieldName];
    }
  });

  const errors = flatten(cleanErrors, { safe: true });

  return (Object.keys(errors || {}) || []).map(fieldName => {
    const errorMsgs = Array.isArray(errors[fieldName])
      ? errors[fieldName]
      : [].map(e => e.toLowerCase()).join(", ");
    const uniqErrorMsgs = Array.from(new Set(errorMsgs));

    return `${humanizeFieldName(fieldName)} ${uniqErrorMsgs}`;
  });
}

export function submitErrorMsgs(submitErrors) {
  return (Object.keys(submitErrors || {}) || []).map(fieldName => {
    submitErrors[fieldName] = submitErrors[fieldName] || [];
    if (fieldName === "base") {
      return `${submitErrors[fieldName].join(", ")}`;
    }
    return `${humanizeString(fieldName)} ${submitErrors[fieldName].join(", ")}`;
  });
}

// Enhances reduxForm HoC by adding an errorMessages prop that contains an array
// of formatted error messages for all types of redux-form errors.
export default function form(props) {
  return FormComponent =>
    connect(state => {
      const baseMsgs = getFormError(props.form)(state) || [];
      const syncMsgs = fieldErrorMsgs(getFormSyncErrors(props.form)(state));
      const asyncMsgs = fieldErrorMsgs(getFormAsyncErrors(props.form)(state));
      const submitMsgs = submitErrorMsgs(
        getFormSubmitErrors(props.form)(state)
      );

      return {
        errorMessages: [
          ...new Set([].concat(syncMsgs, asyncMsgs, submitMsgs, baseMsgs))
        ]
      };
    })(reduxForm({ ...props })(FormComponent));
}



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/form.js